import { ICreateRegister } from "./AuthContextTypes";

export const valuesDefaultInputsControlCompany: ICreateRegister = {
  email: "",
  password: "",
  name: "",
  phone1: "",
};
